import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getUserSkills } from '../../../Auth/Admin/utilities/adminUtils';
import { useAuth } from '../../../Auth/context/AuthContext';
import PageContainer from '../../../PageUtil/PageContainer';
import IconDisplay from '../../../Common/Icons/IconDisplay';

const UserSkills = () => {
  const { isAdmin } = useAuth();
  const { userId } = useParams();
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdmin) {
      loadSkills();
    } else {
      navigate('/dashboard');
    }
  }, [userId, navigate, isAdmin]);

  const loadSkills = async () => {
    setLoading(true);
    try {
      const data = await getUserSkills(userId);
      setSkills(data);
    } catch (err) {
      console.error('Error loading skills:', err);
      setError('Failed to load skills');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageContainer error={error} setError={setError} isAdmin={isAdmin}>
      <div className="py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h3 mb-0">Skills for User: {userId}</h1>
          <button className="btn btn-outline-secondary" onClick={() => navigate('/admin/users')}>
            <i className="bi bi-arrow-left me-2"></i>Back to Users
          </button>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="row g-3">
            {skills.length > 0 ? skills.map(skill => (
              <div key={skill.id} className="col-md-6 col-lg-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <IconDisplay icon={skill.icon} userId={userId} label={skill.name} size={40} />
                          <h5 className="card-title mb-0">{skill.name}</h5>
                        </div>
                        <span className="text-warning">
                            {Array.from({ length: skill.rating || 0 }, (_, i) => (
                                <i key={i} className="bi bi-star-fill"></i>
                            ))}
                        </span>
                    </div>
                    <p className="card-text text-muted small">
                      {skill.description}
                    </p>
                  </div>
                </div>
              </div>
            )) : (
              <div className="col-12 text-center py-5">
                <p className="text-muted">This user has no skills.</p>
              </div>
            )}
          </div>
        )}
      </div>
    </PageContainer>
  );
};

export default UserSkills;
